import React from 'react';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';

export const PreferenceDeleteDialog = props => {
  const { openDeleteDialog, onDeleteDialogClose, deleteJobPreferences, isDeleteInProgress } = props;
  return (
    <GenericDialog
      open={openDeleteDialog}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          event.preventDefault();
          event.stopProgagation();
          return;
        }
      }}
      disableEscapeKeyDown
      maxWidth="sm"
      fullWidth
      dialogTitleProps={{
        style: { paddingTop: '20px' },
        text: 'Delete Preference Set?',
        closeButton: false,
      }}
      dialogActions={[
        {
          text: 'Cancel',
          variant: 'contained',
          onClick: () => onDeleteDialogClose(),
        },
        {
          text: 'Yes',
          variant: 'contained',
          color: 'primary',
          disabled: isDeleteInProgress,
          onClick: () => {
            deleteJobPreferences();
          },
        },
      ]}
    >
      <span>
        <span
          style={{ fontWeight: 500 }}
        >{`Are you sure you want to delete the selected preference set(s) from the list?`}</span>
      </span>
    </GenericDialog>
  );
};
